module.exports = ReactBootstrap;


//////////////////
// WEBPACK FOOTER
// external "ReactBootstrap"
// module id = 41
// module chunks = 0